import CityPageTemplate from "../city-template/CityPageTemplate";
import { evansvilleConfig } from "./data";

export default function EvansvillePage() {
  return <CityPageTemplate config={evansvilleConfig} />;
}